import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 9a2 2 0 1 0 4 0a2 2 0 0 0 -4 0","key":"svg-0"}],["path",{"d":"M4 8v-2a2 2 0 0 1 2 -2h2","key":"svg-1"}],["path",{"d":"M4 16v2a2 2 0 0 0 2 2h2","key":"svg-2"}],["path",{"d":"M16 4h2a2 2 0 0 1 2 2v2","key":"svg-3"}],["path",{"d":"M16 20h2a2 2 0 0 0 2 -2v-2","key":"svg-4"}],["path",{"d":"M8 16a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2","key":"svg-5"}]]

const IconUserScan = createReactComponent('outline', 'user-scan', 'UserScan', __iconNode);

export default IconUserScan;